var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('VueMarkdown',{staticClass:"articalContent markdown-body",staticStyle:{"min-height":"calc(100vh - 134px)","padding":"15px 7% 0px"},attrs:{"source":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }